<section class="container-fluid bg-white">
    <div class="container pt-5">
        <div class="row">
            <div class="col">
                <h1 class="text-center display-3 mb-5" id="faq">Contact Us</h1>
                <hr class="mb-5"> 
            </div>

        </div>
        <div class="row">
            <div class="col-md-4">
                <p>
                    For any questions or inquiries you may have about Family Health Advantage, you can contact us at:
                </p>
                <h6>Address:</h6>
                <address>
                    Family Health Advantage<br>
                    13215 Birch Drive, Suite 200<br>
                    Omaha, NE 68164
                </address>
                <h6>Phone:</h6>
                <p>
                    Toll-free: 833-376-3766
                </p>
                <p>
                    Fax: 402-934-4908
                </p>
            </div>
            <div class="col-md-8 position-relative">
                @if(loading()) {
                    <app-loading-overlay></app-loading-overlay>
                }
                @if(!displaySuccessMessage()) {
                <form [formGroup]="contactForm" (ngSubmit)="submit()">
                    <div class="row g-3">
                        <div class="col-12">
                                <label for="name"class="form-label required">Name</label>
                        </div>
                    </div>
                    <div class="row g-3">
                        <div class="col-12">
                            <input type="text"
                                [class.is-invalid]="
                                    shouldShowError('name')"
                                [class.is-valid]="
                                    contactForm.controls.name.dirty &&
                                    contactForm.controls.name.valid &&
                                    !contactForm.controls.name.errors"
                                class="form-control"
                                [disabled]="loading()"
                                formControlName="name" />
                            @if(shouldShowError('name')) {
                                <div class="invalid-feedback d-block">
                                    Name is required.
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row g-3 mt-2">
                        <div class="col">
                            <label for="email" class="form-label required">Email</label>
                            <input
                                type="text"
                                [class.is-invalid]="
                                    shouldShowError('email_address')"
                                [class.is-valid]="
                                    contactForm.controls.email_address.dirty &&
                                    contactForm.controls.email_address.valid &&
                                    !contactForm.controls.email_address.errors"
                                class="form-control"
                                [disabled]="loading()"
                                formControlName="email_address" 
                            />
                            @if(shouldShowError('email_address')) {
                                <div class="invalid-feedback d-block">
                                    @if(contactForm.controls.email_address.hasError('required')) {
                                        Email is required.
                                    } @else if(contactForm.controls.email_address.hasError('email')) {
                                        Please enter a valid email address.
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row g-3 mt-2 mb-5">
                        <div class="col">
                            <label for="message" class="form-label required">Message</label>
                            <textarea
                                [class.is-invalid]="
                                    shouldShowError('message')"
                                [class.is-valid]="
                                    contactForm.controls.message.dirty &&
                                    contactForm.controls.message.valid &&
                                    !contactForm.controls.message.errors"
                                class="form-control"
                                [disabled]="loading()"
                                formControlName="message"
                                rows="10"></textarea>
                            @if(shouldShowError('message')) {
                                <div class="invalid-feedback d-block">
                                    Message is required.
                                </div>
                            }
                        </div>
                    </div>
                    <div class="d-grid d-flex justify-content-end">
                        @if(loading()) {
                            <div class="contact-submit-status me-3" role="status" aria-live="polite">
                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <span>Submitting your message...</span>
                            </div>
                        }
                        <button
                            class="btn btn-black mb-5 btn-lg rounded-0 d-inline-flex align-items-center gap-2"
                            type="submit"
                            [disabled]="loading() || !contactForm.valid">
                            @if(loading()) {
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span>Submitting...</span>
                            } @else {
                                <span>Submit</span>
                            }
                        </button>
                    </div>
                </form>
                } @else {
                    <p class="display-4">
                        Thank you for contacting us. Someone from our team will reach out to you within the next 24-48 hours. 
                    </p>
                }
            </div>
        </div>
    </div>
</section>
